import { useLoaderData } from 'react-router'

import { EMPTY_LIST } from '../../../constants/common'
import { EmailProfileRaw } from '../EmailProfileRaw'

function EmailMessageProfileRaw() {
  const data = useLoaderData()

  return (
    <EmailProfileRaw
      messages={data ? [data] : EMPTY_LIST}
      subject={data?.subject}
    />
  )
}

export default EmailMessageProfileRaw
